var render, staticRenderFns
import script from "./NbRadioGroup.vue?vue&type=script&lang=js&"
export * from "./NbRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd25c2a",
  null
  
)

export default component.exports